import { APIMethod, fetchData } from "@client";

export async function retrievePasswordQuery(data) {
  const res = await fetchData("/user/retrieve", APIMethod.POST, { data });
  return res.success
}
